import { useEffect, useRef, useState } from 'react';

import { SimResult, SimScenario, toRequest } from './scenario';

import { simulateSmartCharging } from '../../../hooks/smartcharging';

/** Espera a pessoa parar de clicar no +/− antes de pedir o cálculo. */
export const SIMULATION_DEBOUNCE_MS = 300;

/**
 * Recalcula o cenário no smartcharging a cada mudança. Só a resposta do último pedido vale:
 * uma resposta atrasada de um cenário antigo não pode sobrescrever a do atual.
 */
export const useSmartChargingSimulation = (scenario: SimScenario | null) => {
  const [result, setResult] = useState<SimResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const lastRequest = useRef(0);

  useEffect(() => {
    if (!scenario) {
      return undefined;
    }

    const request = lastRequest.current + 1;
    lastRequest.current = request;
    setLoading(true);

    const timer = setTimeout(async () => {
      try {
        const { data } = await simulateSmartCharging(toRequest(scenario));

        if (lastRequest.current === request) {
          setResult(data);
          setError(false);
        }
      } catch {
        if (lastRequest.current === request) {
          setError(true);
        }
      } finally {
        if (lastRequest.current === request) {
          setLoading(false);
        }
      }
    }, SIMULATION_DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [scenario]);

  return { result, loading, error };
};
